import React, { Component } from 'react'
import { connect } from 'react-redux'

import { unsetData, setCars } from '../store/appData'

const WithData = WrappedComponent => {
  class With extends Component {
    render() {
      return <WrappedComponent {...this.props} />
    }
  }

  return connect(
    state => ({
      appData: state.data,
      cars: state.data.cars && state.data.cars.length ? state.data.cars : [],
    }),
    dispatch => ({
      unsetData: () => dispatch(unsetData),
      setCars: cars => dispatch(setCars(cars)),
    })
  )(With)
}

export default WithData
